const STORAGE_KEY = "dungeon-raid-floor-clears/v1";

function clearKey(attackerUid: string, defenderUid: string, floor: number): string {
  return `${attackerUid}:${defenderUid}:${floor}`;
}

function readLog(): Record<string, true> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const out: Record<string, true> = {};
    for (const [k, v] of Object.entries(parsed)) {
      if (v === true) out[k] = true;
    }
    return out;
  } catch {
    return {};
  }
}

function writeLog(log: Record<string, true>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(log));
  } catch {
    /* quota */
  }
}

export function hasDungeonRaidFloorClear(
  attackerUid: string,
  defenderUid: string,
  floor: number,
): boolean {
  const log = readLog();
  return log[clearKey(attackerUid, defenderUid, floor)] === true;
}

export function markDungeonRaidFloorClear(
  attackerUid: string,
  defenderUid: string,
  floor: number,
): void {
  const log = readLog();
  log[clearKey(attackerUid, defenderUid, floor)] = true;
  writeLog(log);
}
